import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

type GoatCounterCountArgs = {
  path: string;
  title: string;
};

type GoatCounterApi = {
  count?: (args: GoatCounterCountArgs) => void;
};

declare global {
  interface Window {
    goatcounter?: GoatCounterApi;
  }
}

const SCRIPT_POLL_INTERVAL_MS = 100;
const MAX_SCRIPT_POLLS = 100;

const buildTrackedPath = (pathname: string): string => {
  if (pathname.startsWith('/app')) {
    return pathname;
  }

  if (pathname === '/') {
    return '/app';
  }

  return `/app${pathname}`;
};

const GoatCounterTracking: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const trackedPath = buildTrackedPath(location.pathname);
    let pollCount = 0;

    const timer = window.setInterval(() => {
      const count = window.goatcounter?.count;
      if (!count) {
        pollCount += 1;
        if (pollCount >= MAX_SCRIPT_POLLS) {
          window.clearInterval(timer);
        }
        return;
      }

      window.clearInterval(timer);
      count({
        path: trackedPath,
        title: document.title,
      });
    }, SCRIPT_POLL_INTERVAL_MS);

    return () => {
      window.clearInterval(timer);
    };
  }, [location.pathname]);

  return null;
};

export default GoatCounterTracking;
